import React from 'react';
import loadable from '@loadable/component';

import withPage, { loadGraphQLData } from '../page';

const MDP = loadable(() => import('./components'));

export default {
    component: withPage(MDP, { wrapperClassName: 'mdp-root', showWordCloud: true, useV2: true, useGraphQL: true }),
    loadData: loadGraphQLData,
};
